import { defineComponent as p, ref as S, onMounted as B, watch as I, onBeforeUnmount as x, h as m, Fragment as L } from "vue";
import { focusFirstDescendant as R, focusLastDescendant as A } from "./ghl-ui.es777.js";
import { createId as C } from "./ghl-ui.es778.js";
import { on as M, off as g } from "./ghl-ui.es725.js";
import { resolveTo as T } from "./ghl-ui.es779.js";
import { getPreciseEventTarget as _ } from "./ghl-ui.es780.js";
let r = [];
const V = p({
  name: "FocusTrap",
  props: {
    disabled: Boolean,
    active: Boolean,
    autoFocus: {
      type: Boolean,
      default: !0
    },
    onEsc: Function,
    initialFocusTo: String,
    finalFocusTo: String,
    returnFocusOnDeactivated: {
      type: Boolean,
      default: !0
    }
  },
  setup(n) {
    const i = C(), u = S(null), E = S(null);
    let s = !1, o = !1;
    const F = typeof document > "u" ? null : document.activeElement;
    function a() {
      return r[r.length - 1] === i;
    }
    function d(e) {
      var t;
      e.code === "Escape" && a() && ((t = n.onEsc) === null || t === void 0 || t.call(n, e));
    }
    B(() => {
      I(() => n.active, (e) => {
        e ? (y(), M("keydown", document, d)) : (g("keydown", document, d), s && b());
      }, {
        immediate: !0
      });
    }), x(() => {
      g("keydown", document, d), s && b();
    });
    function h(e) {
      if (!o && a()) {
        const t = v();
        if (t === null || t.contains(_(e)))
          return;
        l("first");
      }
    }
    function v() {
      const e = u.value;
      if (e === null)
        return null;
      let t = e;
      for (; t = t.nextSibling, !(t === null || t instanceof Element && t.tagName === "DIV"); )
        ;
      return t;
    }
    function y() {
      var e;
      if (!n.disabled) {
        if (r.push(i), n.autoFocus) {
          const { initialFocusTo: t } = n;
          t === void 0 ? l("first") : (e = T(t)) === null || e === void 0 || e.focus({ preventScroll: !0 });
        }
        s = !0, document.addEventListener("focus", h, !0);
      }
    }
    function b() {
      var e;
      if (n.disabled || (document.removeEventListener("focus", h, !0), r = r.filter((c) => c !== i), a()))
        return;
      const { finalFocusTo: t } = n;
      t !== void 0 ? (e = T(t)) === null || e === void 0 || e.focus({ preventScroll: !0 }) : n.returnFocusOnDeactivated && F instanceof HTMLElement && (o = !0, F.focus({ preventScroll: !0 }), o = !1);
    }
    function l(e) {
      if (a() && n.active) {
        const t = u.value, c = E.value;
        if (t !== null && c !== null) {
          const f = v();
          if (f == null || f === c) {
            o = !0, t.focus({ preventScroll: !0 }), o = !1;
            return;
          }
          o = !0;
          const k = e === "first" ? R(f) : A(f);
          o = !1, k || (o = !0, t.focus({ preventScroll: !0 }), o = !1);
        }
      }
    }
    function w(e) {
      if (o)
        return;
      const t = v();
      t !== null && (e.relatedTarget !== null && t.contains(e.relatedTarget) ? l("last") : l("first"));
    }
    function D(e) {
      o || (e.relatedTarget !== null && e.relatedTarget === u.value ? l("last") : l("first"));
    }
    return {
      focusableStartRef: u,
      focusableEndRef: E,
      focusableStyle: "position: absolute; height: 0; width: 0;",
      handleStartFocus: w,
      handleEndFocus: D
    };
  },
  render() {
    const { default: n } = this.$slots;
    if (n === void 0)
      return null;
    if (this.disabled)
      return n();
    const { active: i, focusableStyle: u } = this;
    return m(L, null, [
      m("div", {
        "aria-hidden": "true",
        tabindex: i ? "0" : "-1",
        ref: "focusableStartRef",
        style: u,
        onFocus: this.handleStartFocus
      }),
      n(),
      m("div", {
        "aria-hidden": "true",
        style: u,
        ref: "focusableEndRef",
        tabindex: i ? "0" : "-1",
        onFocus: this.handleEndFocus
      })
    ]);
  }
});
export {
  V as FocusTrap
};
